import { render } from "./DynamicForm.vue?vue&type=template&id=25c31e89"
import script from "./DynamicForm.vue?vue&type=script&lang=js"
export * from "./DynamicForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__